import VueCookies from "vue-cookies";
import { EncryptAES, DecryptAES } from "./crypto";
import store from "../../store/store"; 
const ulsname = "_cmauls";     
const utkn = "_cmautk";        
const sessckname = "_cmsess";  
const sessexp = "30d";         

function SetUser(user) {
  if (!user) {
    localStorage.removeItem(ulsname);
  } else {
    let tk = LoadCookie(utkn);
    if (tk) {
      localStorage.setItem(ulsname, EncryptAES(JSON.stringify(user), tk));
    }

    store.commit("setUser", user);
  }
}

function LoadUser() {
  if (localStorage.getItem(ulsname) !== null) {
    try {
      let tk = LoadCookie(utkn);
      if (!tk) {
        throw new Error("Token bilgisi bulunamadı.");
      }
      let u = JSON.parse(DecryptAES(localStorage.getItem(ulsname), tk));
      return u;
    } catch (err) {
      console.error("Decryption error:", err);
      return err;
    }
  }
}

function SetUserToken(tkn) {
  SetCookie(utkn, tkn);
}

function SetCookie(name, value, exp = sessexp) {
  VueCookies.set(name, value, {
    expires: exp,
    path: "/",
    secure: true,
    sameSite: "Strict",
  });
}

function SetSession(tkn) {
  SetCookie(sessckname, tkn, "Session");
}

function GetSession() {
  return VueCookies.get(sessckname);
}

function RemoveSession() {
  VueCookies.remove(sessckname);
}

function LoadCookie(name) {
  if (VueCookies.isKey(name)) return VueCookies.get(name);
}

function SaveStatePlugin(store) {
  store.subscribe((mutation, state) => {
    if (mutation.type !== "setUser") {
      SetUser(state.user);
    }
  });
}

function AuthUser(user, utk, stk) {
  SetUserToken(utk);
  SetUser(user);
  SetSession(stk);
}

export {
  SetUser,
  LoadUser,
  SaveStatePlugin,
  GetSession,
  RemoveSession,
  AuthUser,
  SetCookie,
  LoadCookie,
  ulsname,
};
